import { Loader } from "@nef/core"

const NasdaqLoader = () => {
  return (
    <>
    <div className="loader-wrapper">
      <div className="loader">
        <Loader isLoading />
      </div>
    </div>
    </>
  )
}

export default NasdaqLoader
